export const baseUrl = process.env.REACT_APP_API_URL || "https://desa-seguimiento.superdesalud.gob.cl/ws";
export const BASE_URL_Consultas = process.env.REACT_APP_API_CONSULTAS_URL || "https://desa-api-servicios.superdesalud.gob.cl"
export const sitekeyRecaptcha = "6LdDE8EZAAAAAGeEYRoiATfkcFsvONhXpwu-Jxy6";
export const isDev = process.env.REACT_APP_ISDEV || false;
export const GA_TRACKING_CODE = 'G-2RFLKBK0L3'
export const GA_TRACKING_CODE_UA = 'UA-191803678'

export const ALFRESCO_URL = process.env.REACT_APP_ALFRESCO_URL || "http://webdocsdesa.superdesalud.gob.cl/share/proxy/alfresco-noauth/api/internal/shared/node/content/";
export const baseUrlClaveUnice = process.env.REACT_APP_BASE_URL_CLAVE_UNICA || "https://api.claveunica.gob.cl/api/v1/accounts/app/logout";
export const envSentry = process.env.REACT_APP_SENTRY_ENVIROMENT || "local";
export const dsnSentry = process.env.REACT_APP_SENTRY_DSN || "https://28900ad3b70a43cdb020d94d069070a1@desa-sentry.superdesalud.gob.cl/4";
/* export const CORP_BLUE = '#3f51b5'; */
export const CORP_BLUE = '#0064ac';


